import React, { useContext, useState } from "react";
import { Accordion, Form, Grid, Label, Table } from "semantic-ui-react";
import QuestionSet from "../components/QuestionSet";
import { BasicLoadingState } from "../State";
import { handleSubmit, store } from "../store";

const ExperienceRatingQuestionnaire: React.FunctionComponent = () => {
    const [state, setState] = useState<BasicLoadingState>({ isLoading: false });
    const globalState = useContext(store);
    const { dispatch } = globalState;
    const panels = [
        {
            key: 'questions',
            title: {
                content: <Label size="huge" color="green">Questions? Click <u>here</u> to View our FAQ</Label>,
                icon: <i className="invisible"></i>,
            },
            content: {
                content: (
                    <Table striped unstackable inverted={globalState.state.appState.isDarkTheme}>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell width={8} textAlign="center">QUESTION</Table.HeaderCell>
                                <Table.HeaderCell width={8} textAlign="center">ANSWER</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>How do I locate an insured's renewal experience modification?</Table.Cell>
                                <Table.Cell>Go to <a href="https://www.njcrib.com">www.njcrib.com</a>, click Online Services then Experience Rating Mods. (under Information Services) and select the appropriate Select a Search option. If the modification search does not provide the desired information, call (973) 622-6014, Option 1 to leave a message.</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Can a producer submit an inquiry to the Portal on behalf of the insured?</Table.Cell>
                                <Table.Cell>Yes, but if you are not the producer of record on the current policy, you must attach a letter of authority signed by the insured on the employer's letterhead with your submission.</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Why can't I find the name of the insured?</Table.Cell>
                                <Table.Cell>Is the Policy Effective Date correct?  If so, you should type the first few characters of the insured's name, at which point the name will populate and you can choose the correct name of the insured.</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Do I need to fill in all fields?</Table.Cell>
                                <Table.Cell>Yes, all fields with an * must be answered or the submission will not be accepted.</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Can I request Experience Rating Data and/or Unit Statistical Reports through the Portal?</Table.Cell>
                                <Table.Cell>The only way to obtain such information is found here:<br /><a href="https://www.njcrib.com/DocumentLibrary/USR_XROrderForms">USR/XR Order Forms (njcrib.com)</a></Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                ),
            },
        },
    ];

    return (
        <Grid centered className="QuestionSetContainer">
            <Grid.Row>
                <Label size={"big"}><b>For questions concerning an absent renewal modification, please call (973) 622-6014, Option 1.</b></Label>
            </Grid.Row>
            <Grid.Row>
                <Accordion panels={panels} />
            </Grid.Row>
            <Grid.Row>
                <Form size={"small"} method="post" action="/Index" encType="multipart/form-data">
                    {
                        <QuestionSet isLoading={state.isLoading} icon={state.icon}
                            onSubmit={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => handleSubmit({ state, setState },
                                globalState.state, e, "XRP")}
                            questionAnswers={globalState.state.answerState!} />
                    }
                </Form>
            </Grid.Row>
        </Grid>
    );
};

export default ExperienceRatingQuestionnaire;
